import { PayloadAction } from "@reduxjs/toolkit";
import { createApi, createSlice } from "utils/@reduxjs/toolkit";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";
import { Saga } from "./saga";
import { ManageProfileState } from "./types";
import { endpoints, formatErrors, baseQuery } from "utils/api/endpoints";

export const initialState: ManageProfileState = {};

const slice = createSlice({
  name: "manageProfile",
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const api = createApi({
  reducerPath: "manageProfileApi",
  baseQuery,
  endpoints: (builder) => ({
    getProfile: builder.query<any, any>({
      query: (params) => {
        return {
          ...endpoints.getProfile,
          params,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    updateProfile: builder.mutation<any, any>({
      query: (body) => {
        return {
          ...endpoints.updateProfile,
          body,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    fileUpload: builder.mutation<any, any>({
      query: (body) => {
        return {
          ...endpoints.fileUpload,
          body,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
  }),
});

export const { actions: Actions } = slice;

export const useManageProfileSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return { actions: slice.actions, ...api };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
